import { useQuery } from '@tanstack/react-query'
import { fetchFleetSummary } from '../api/api'

const FLEET_STALE_TIME = 5 * 60 * 1000

export function useFleetSummary(enabled = true) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['fleet-summary'],
    queryFn: fetchFleetSummary,
    staleTime: FLEET_STALE_TIME,
    enabled,
  })

  return { summary: data ?? null, isLoading, isError }
}
